export const content = {
  en: {
    title: 'Important',
    description: `To proceed, confirm that you've read, understood, and agree to our `,
    managementeMandate: 'Crypto Bundle Discretionary Management Mandate',
    bundleMethodology: 'Crypto Bundle Methodology',
    riskDisclosures: 'Crypto Risk Disclosures',
    generalRiskDisclosures: 'General Risk Disclosures.',
    confirmButton: 'Confirm & Agree',
    and: 'and',
  },
  de: {
    title: 'Wichtig',
    description: `Um fortzufahren, bestätige bitte, dass du die folgenden Dokumente gelesen und verstanden hast und ihnen zustimmst: `,
    managementeMandate: 'Crypto Bundle Discretionary Management Mandate',
    bundleMethodology: 'Crypto Bundle Methodology',
    riskDisclosures: 'Crypto Risk Disclosures',
    generalRiskDisclosures: 'General Risk Disclosures.',
    confirmButton: 'Ich bestätige und stimme zu',
    and: 'und',
  },
};
